export const infoBoxData = {
  qInfo: { qType: "pivothypercube" },
  qHyperCubeDef: {
    qDimensions: [
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["SchoolName_SchoolProfiles"],
          qFieldLabels: ["School Name"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        }
      },
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["domain"],
          qFieldLabels: ["Domain"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        }
      },
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["report"],
          qFieldLabels: ["Report Type"],
        }
      }
    ],
    qMeasures: [
      { qDef: { qLabel: "Points Possible", qDef: "=Sum(pts_poss)" } },
      { qDef: { qLabel: "Points Earned", qDef: "=Sum(pts_earned)" } }
    ]
  }
};
